"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function(
  $log,
  openFinApi,
  RediPlusWindowRepository,
  RediWindowRepository
) {
  var that = this;

  var EVENT = {
    CONTEXT_RECEIVED: "contextReceived",
    LINKED: "linked",
    UNLINKED: "unlinked",
    SHOW_FEEDBACK: "showFeedbackForLinking",
    HIDE_FEEDBACK: "hideFeedbackForLinking",
    WORKSPACE_CHANGED: "workspaceChanged",
    ALLOWED: "allowed",
    DENIED: "denied",
    DISABLED: "disabled",
    APP_CLOSED: "appClosed",
    APP_OPENED: "appOpened",
    HEARTBEAT: "heartbeat",
    TRADE_TICKET: "trading.openTicket"
  };

  var EXCLUSIVE_SIGN_ON_STATUS = "eso";

  var windowInstanceIdToOnClosedCallbackMap = {};
  var eikonApplicationOpenedMessageHandler;
  var esoMessageHandler;

  that.registerEikonApplicationOpenedMessageHandler = function(
    givenApplicationOpenedMessageHandler
  ) {
    eikonApplicationOpenedMessageHandler = givenApplicationOpenedMessageHandler;
  };

  that.registerExclusiveSignOnMessageHandler = function(
    givenEsoMessageHandler
  ) {
    esoMessageHandler = givenEsoMessageHandler;
  };

  that.onMessage = function(data) {
    try {
      var msg = JSON.parse(data);
      var command = msg.command;
      switch (command) {
        case EVENT.ALLOWED:
          $log.info("Allowed!");
          break;
        case EVENT.DENIED:
          $log.info("Denied!");
          break;
        case EVENT.DISABLED:
          $log.info("Disabled!");
          break;
        case EVENT.CONTEXT_RECEIVED:
          publishContextToOpenfin(
            JSON.parse(msg.context),
            msg.targetInstanceId
          );
          break;
        case EVENT.LINKED:
          $log.info("Linked!");
          break;
        case EVENT.UNLINKED:
          $log.info("Unlinked");
          handleUnlinkedMessage(msg.instanceId, msg.targetInstanceId);
          break;
        case EVENT.SHOW_FEEDBACK:
          $log.info("Show Feedback!");
          break;
        case EVENT.HIDE_FEEDBACK:
          $log.info("Hide Feedback!");
          break;
        case EVENT.WORKSPACE_CHANGED:
          $log.info("Workspace Changed!");
          break;
        case EVENT.APP_CLOSED:
          $log.info("appClosed: " + data);
          handleApplicationClosed(msg.instanceId);
          break;
        case EVENT.APP_OPENED:
          $log.info("appOpened: " + data);
          handleApplicationOpened(msg);
          break;
        case EVENT.HEARTBEAT:
          $log.info("heartbeat: " + data);
          handleHeartbeat(msg.status);
          break;
        case EVENT.TRADE_TICKET:
          $log.info("trade ticket: " + data);
          if (
            !msg.payload ||
            !msg.payload.legs ||
            msg.payload.legs.length !== 1
          ) {
            $log.error("Can only handle legs with a length of 1");
            break;
          }
          openTradeTicket(msg.appId, msg.payload.legs[0]);
          break;
        default:
          $log.info("Unknown command: ", command);
          break;
      }
    } catch (error) {
      $log.info("WS onmessage:", error);
    }
  };

  that.addOnWindowClosedCallback = function(
    windowInstanceName,
    onClosedCallback
  ) {
    windowInstanceIdToOnClosedCallbackMap[
      windowInstanceName
    ] = onClosedCallback;
  };

  function handleUnlinkedMessage(instanceId, targetInstanceId) {
    var rediWindowId = RediPlusWindowRepository.getRediPlusWindowId(
      targetInstanceId
    );
    var eikonWindow = RediWindowRepository.getWindowByInstanceName(instanceId);
    if (rediWindowId && eikonWindow) {
      eikonWindow.getNativeId().then(function(nativeId) {
        publishUnlinkedToOpenfin(rediWindowId, targetInstanceId, nativeId);
      });
    }
  }

  function handleHeartbeat(status) {
    if (status === EXCLUSIVE_SIGN_ON_STATUS && esoMessageHandler) {
      esoMessageHandler();
    }
  }

  function handleApplicationClosed(instanceId) {
    var callbackFunction = windowInstanceIdToOnClosedCallbackMap[instanceId];
    if (callbackFunction) {
      callbackFunction.apply();
      delete windowInstanceIdToOnClosedCallbackMap[instanceId];
    } else {
      $log.info("No close window callback defined for " + instanceId);
    }
  }

  function handleApplicationOpened(msg) {
    $log.info("AppOpened Message " + JSON.stringify(msg));
    eikonApplicationOpenedMessageHandler(msg);
  }

  function openTradeTicket(appId, trade) {
    $log.info("Opening trade ticket for app ID = " + appId);
    var windowName = convertAppIdToRediWindow(appId);
    if (windowName) {
      $log.info("Opening window " + windowName);
      var side = trade.side ? trade.side.toUpperCase() : "BUY";
      openFinApi.publish("open-redi-window", {
        Window: windowName,
        data: {
          Symbol: trade.ric,
          Side: side,
          Quantity: trade.size,
          Price: trade.price
        }
      });
    }
  }

  function convertAppIdToRediWindow(appId) {
    switch (true) {
      case /\.MONTAGE$/.test(appId):
        return "Montage";
      case /\.MONTAGEII$/.test(appId):
        return "Montage2";
      case /\.QUICKTRADE$/.test(appId):
        return "RapidOrderEntry";
      case /\.OPTIONSERIES/.test(appId):
        $log.info(
          "Option Series was selected, but REDI only has Option Montage available, opening OptionMontage..."
        );
        return "OptionMontage";
      case /\.OPTIONMONTAGE/.test(appId):
        return "OptionMontage";
      default:
        $log.error("No REDI apps associated with " + appId);
        return undefined;
    }
  }

  function publishUnlinkedToOpenfin(
    sourceWindowId,
    targetWindowId,
    targetNativeWindowId
  ) {
    openFinApi.publish("unregister-link", {
      sourceWindowId: sourceWindowId,
      targetNativeWindowId: targetNativeWindowId,
      targetWindowId: targetWindowId
    });
  }

  function publishContextToOpenfin(context, targetInstanceId) {
    var rediWindowId = RediPlusWindowRepository.getRediPlusWindowId(
      targetInstanceId
    );
    context = translateEikonContextToRedi(context);
    if (rediWindowId) {
      openFinApi.publish("data-message", {
        windowName: rediWindowId,
        data: context
      });
    } else {
      $log.info(
        "Received a sxs data message for SXS id " +
          targetInstanceId +
          " that could not be linked to a R+ window instance."
      );
    }
  }

  function translateEikonContextToRedi(context) {
    return {
      entities: _.chain(context.entities)
        .filter(entity => !!entity.RIC)
        .map(translateEikonEntityToRedi)
        .value()
    };
  }

  function translateEikonEntityToRedi(entity) {
    var symbolStartingWithDot = /^\./;
    var rediCharacterReplacementForDot = "^";
    return _.defaults(
      {
        REDI_RIC: entity.RIC.replace(
          symbolStartingWithDot,
          rediCharacterReplacementForDot
        )
      },
      entity
    );
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/sideBySideMessageHandler.js